var map = {
	"./acer.avif": 7649,
	"./cma-cmg.avif": 6077,
	"./cosco.avif": 6187,
	"./daman.avif": 7335,
	"./dhl.avif": 4950,
	"./digital-du.avif": 5938,
	"./en.avif": 5213,
	"./nama.avif": 5985,
	"./nbb.avif": 9872,
	"./rta.avif": 4315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6012;